export const getDefaultFiltersCount = filters => {
  const filterCount = Object.values(filters).reduce((acc, cur) => {
    return acc + (cur.length === 0 ? 0 : 1)
  }, 0)
  return filterCount
}
